module.exports = __webpack_public_path__ + "static/hemp-square.2bef5596.jpg";